import { EventJson } from '@ssp/inscreva-sse-models';
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';

import { Event } from '@/models/event';
import httpService from '@/services/http';

import { StoreSingleton } from '.';
import { sessionStore } from './session';

@Module({
  name: 'eventStore',
  namespaced: true,
  preserveState: true,
  stateFactory: true,
  dynamic: true,
  store: StoreSingleton.getInstance(),
})
export default class EventStore extends VuexModule {
  private _event: Event;

  @Mutation
  fromJson(json: any) {
    this._event = EventJson.fromJson(json);
  }

  @Mutation
  select(event: Event): void {
    this._event = event;
  }

  get event(): Event {
    return this._event;
  }

  @Action({ rawError: true })
  async create(event: Event): Promise<Event> {
    const newEvent: Event = (await httpService(sessionStore.session).post('/event/', event)).data;
    const { session } = sessionStore;
    session.event = newEvent;
    sessionStore.select(session);
    return newEvent;
  }

  @Action({ rawError: true })
  async update(event: Event): Promise<Event> {
    const updatedEvent = (await httpService(sessionStore.session).put(`/event/${event._id}`, event)).data;
    const { session } = sessionStore;
    session.event = session.event?._id === updatedEvent._id ? updatedEvent : session.event;
    sessionStore.select(session);
    return updatedEvent;
  }

  @Action({ rawError: true })
  async remove(id: string): Promise<Event> {
    return (await httpService(sessionStore.session).delete(`/event/${id}`)).data;
  }

  @Action({ rawError: true })
  async list(query: Record<string, any> = {}): Promise<Array<Event>> {
    return (
      await httpService(sessionStore.session).get('/event/', {
        params: query,
      })
    ).data;
  }

  @Action({ rawError: true })
  async findById(id: string): Promise<Event> {
    return (await httpService(sessionStore.session).get(`/event/findById/${id}`)).data;
  }
}
